import { FlexCol } from '@/components/common/Flex';
import { Grid, GridProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface TwoColumnLayoutProps
    extends Omit<GridProps, 'left' | 'right'> {
    order?: 'normal' | 'reverse';
    left?: ReactNode;
    right?: ReactNode;
}

export default function TwoColumnLayout({
    order = 'reverse',
    left,
    right,
    ...props
}: TwoColumnLayoutProps) {
    const leftOrder = order === 'reverse' ? [2, 1] : [1, 2];
    const rightOrder = order === 'reverse' ? [1, 2] : [2, 1];

    return (
        <Grid
            templateColumns={['1fr', 'repeat(2, minmax(0, 1fr))']}
            gap={12}
            {...props}
        >
            <FlexCol order={leftOrder}>{left}</FlexCol>
            <FlexCol order={rightOrder}>{right}</FlexCol>
        </Grid>
    );
}
